import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const MondayContext = createContext();

export const MondayProvider = ({ children }) => {
  const [meetingsData, setMeetingsData] = useState(null);
  const [projectsData, setProjectsData] = useState(null);
  const [commentsData, setCommentsData] = useState(null);

  const fetchMeetingsData = async () => {
    try {
      const response = await axios.get(
        "https://api3.alachuacounty.us/forward-focus-api/api/meetings"
      );
      setMeetingsData(response.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchProjectsData = async () => {
    try {
      const response = await axios.get("http://localhost:5454/api/projects");
      setProjectsData(response.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchCommentsData = async () => {
    try {
      const response = await axios.get(
        "https://api3.alachuacounty.us/forward-focus-api/api/comments"
        // "http://localhost:5454/api/comments"
      );
      setCommentsData(response.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchMeetingsData();
    // fetchProjectsData();
    fetchCommentsData();
  }, []);

  return (
    <MondayContext.Provider
      value={{
        meetingsData,
        projectsData,
        commentsData,
        fetchMeetingsData,
        fetchProjectsData,
        fetchCommentsData,
      }}
    >
      {children}
    </MondayContext.Provider>
  );
};
